<div class=" scrollbar app">
    <div class="pad15 withpopupCard card">
        <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-3">
                <div class="flmid">
                    <div class="flgrow">
                        <strong><span class="font16 fontnormal" translate>lblIsInvoiceCompleted</span>:&nbsp;{{isInvoiceComplete}}&nbsp;</strong>
                    </div>
                </div>
            </div>
            <div class="font16 fontbold ml-auto mr-3">
                <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;
                <span class="font16 fontnormal" translate>lblResults</span>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="table-responsive" >
            <table class="tablest1 fixed-header">
                <thead>
                    <tr>
                        <th style="width: 5%" scope="col">#</th>
                        <th style="width: 5%" scope="col" translate>lblInvoiceNumber</th>
                        <th scope="col" translate>lblRegNumber</th>
                        <th scope="col" translate>lblVinNumber</th>
                        <th scope="col" translate>lblBillToCustomer</th>
                        <th style="width: 10%" scope="col" translate>lblPaymentMethod</th>
                        <th style="width: 10%" scope="col" translate>lblPaymentTerms</th>
                        <th scope="col" class="text-right" translate><span
                            translate>lblInvoiceAmount</span></th>
                        <th scope="col" class="text-right" translate><span
                            translate>lblInvoiceAmount</span><br><span class="text-sm1" translate>lblInclVAT</span></th>
                        <th style="width: 10%" scope="col" translate>lblDueDate</th>
                        <th style="width: 10%" scope="col" translate>lblPostedDate</th>
                        <th scope="col" translate>lblCreatedBy</th>
                        <th style="width: 5%" class="text-center" scope="col" translate>lblAction</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="postedInvoiceList?.length > 0; else load_else">
                        <tr *ngFor="let comm of postedInvoiceList; let i=index">
                            <td>{{i+1}}</td>
                            <td>
                                <ngb-highlight [result]="comm.invoiceNo"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.licensePlateNo"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.chassisNo"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.billToCustomerNo"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.paymentMethod"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.paymentTerms"></ngb-highlight>
                            </td>
                            <td class="text-right">{{comm.invoiceAmount| number:'1.2-2'}}</td>
                            <td class="text-right">{{comm.invoiceAmountVat| number:'1.2-2'}}</td>
                            <td>
                                <ngb-highlight [result]="comm.dueDate | date:'shortDate'"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.postedDate | date:'shortDate'"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.generatedBy"></ngb-highlight>
                            </td>
                            <td class="nowrap text-center">
                                <a class="btn btn-ico" ngbTooltip="{{'lblPreview' | translate}}" (click)="onDownload(comm.invoiceNo, true, previewModal)">
                                    <em class="far fa-eye fa-lg"></em>
                                </a>
                                <a class="btn btn-ico" ngbTooltip="{{'lblDownloadInvoice' | translate}}" (click)="onDownload(comm.invoiceNo)" *ngIf="isDownloadVisible">
                                    <em class="fas fa-download fa-lg"></em>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="14" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>

<ng-template #previewModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>Invoice Preview - {{ editAppointmentService.appointmentDetails.workOrderNo }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body" style="max-height: 80vh !important;">
        <div *ngIf="trustedBlobUrl">
            <iframe id="fraDisabled" [src]="trustedBlobUrl" width="100%" height="700px" frameborder="0"></iframe>
          </div>
    </div>
</ng-template>